import user from "../model/useInfor"

const state = {
  /*重复客资*/
  repeatKz: {
    stateShow: false,
    repeatColumns: [
      {
        title: '编号',
        key: 'id',
        width:60,
      },
      {
        title: '当前客服',
        key: 'appointname',
        width:100,
        ellipsis: true,
        render: (h,params)=>{
          if(params.row.appointname && params.row.groupname){
            return h('span',{},params.row.groupname + '/'+ params.row.appointname)
          }else{
            return h('span',{},params.row.appointname)
          }
        }
      },
      {
        title: '渠道来源',
        key: 'channelid',
        width: 100,
        ellipsis: true,
        render(h, params){
          let sourceMap = user.state.pageDict.sourceMap
          let channelMap = user.state.pageDict.channelMap
          if (params.row.channelid) {
            if (channelMap[params.row.channelid]) {
              return h('span', {}, [
                  h('img', {
                    attrs: {
                      title: channelMap[params.row.channelid].channelName,
                      src: sourceMap[params.row.sourceid].srcImg
                    },
                    style: {
                      height: '18px',
                      'margin-right': '4px',
                      'vertical-align': 'middle',
                      cursor: 'pointer',
                    }
                  }),
                  sourceMap[params.row.sourceid].srcName
                ]
              )
            }
          }
        }
      },
      {
        title: '联系方式',
        key: 'phone',
        width: 150,
        ellipsis: true,
        render: (h, params) => {
          if (params.row.kzphone) {
            return h('span', '电话：' + params.row.kzphone)
          } else if (params.row.kzwechat) {
            return h('span', '微信：' + params.row.kzwechat)
          } else if (params.row.kzqq) {
            return h('span', 'QQ：' + params.row.kzqq)
          } else if (params.row.kzww) {
            return h('span', '旺旺：' + params.row.kzww)
          }
        }
      },
      {
        title: '状态',
        key: 'statusid',
        ellipsis: true,
        render: (h, params) => {
          if (params.row.statusid) {
            if (user.state.pageDict.statusMap[params.row.statusid]) {
              return h('span', {}, user.state.pageDict.statusMap[params.row.statusid].statusName)
            }
          }
        }
      },
      {
        title:'操作',
        width:130,
        render:(h,params) => {
          return h("repeat-operation",{
            props:{
              operation:params.row
            }
          })
        }
      }
    ],
    repeatData: [],
  }
}

const getters = {
  repeatKz: state => {
    return state.repeatKz
  }
}

const mutations = {
  setRepeatKz: (state, data) => {
    if (!data.length) {
      state.repeatKz.repeatData = []
      state.repeatKz.stateShow = false
    } else {
      state.repeatKz.repeatData = data
      state.repeatKz.stateShow = true
    }
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modelState/repeat-kz.js